import React from "react";
import Amplify, { Auth } from "aws-amplify";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import { toast } from 'react-toastify';
import scrollToComponent from "react-scroll-to-component";
import loader from "../../images/Spin-1s-107px.gif";
// import 'react-toastify/dist/ReactToastify.css';

import {
  getSettlemetEnrichmentQuestion,
  getAllSettlement,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
  saveEnrichmentAnswer,
  getAttentionSettlementForUser,
  getCompleteSettlementForUser,
  getCompletedSettlements,
  requestDismissSettlement,
  getAllFilteredDSettlement,
  saveSettlementAnswers,
  clearDataSettlmentanswers,
  getPromotedSettlementByUserId,
  RecieveConsumerUserDataClear,
  RecieveBussnessUserDataClear,
  requestDismissSettlementResponse,
  getAllDashboard,
  getUserDashboardSettlementsCounts,
  getConsumerUser,
  logoutUser,
  clearDataEmail,
  setPageName,
} from "../../Actions/actions";
import * as SecretKeys from "../../ENV.json";
import Dashboard from "./dashboard";

Amplify.configure(SecretKeys.awsUserpool);
// const userid = localStorage.getItem('userId');

class DashboardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSettlementData: {},
      featureSettlement: {},
      attentionSettlement: {},
      completeSettlement : {},
      allEnrichmentQuestion: {},
      promotedSettlement: {},
      ReciveSettlmentanswersResponseData: [],
      suserid: localStorage.getItem("userId"),
      isLoader: false,
      intervalId: 0,
      requestDismissSettlementStatus: []
    };
    // this.handleNav();
  }

  // handleNav = () => {
  //   this.props.enableNav();
  // }

  componentWillUnmount() {
    this.props.clearDataSettlmentanswers();
  }

  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending'
        && !!localStorage.getItem('paymentFailedButLetUserIn') === false) {
      this.context.router.history.push('/add-payment-method');
    }
    //const { data: {pageName} } = this.props
    // if (localStorage.getItem("paymentStatus") === "pending" && pageName === "login") {
    //   // localStorage.clear();
    //   Auth.signOut()
    //     .then(async () => {
    //       // await this.props.logoutUser();
    //       // this.props.clearDataEmail();
    //       this.context.router.history.push("/");
    //     })
    //     .catch(error => error);
    // }

    // const {data} = this.props
    // const AuthInfo = localStorage.getItem('userId');
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    const { router } = this.context;
    if (userObject) {
      if (typeof userObject.userDto !== "undefined") {
        if (typeof userObject.userDto.roleName !== "undefined") {
          if (userObject.userDto.roleName === "Affiliate" || userObject.userDto.roleName === "Affiliate-SubUser" ) {
            if(userObject.userDto.parentAffiliateUser === "Yes"){
              router.history.push("/parent-affiliate");
            }else{
              router.history.push("/affiliate");
            }
          }
        }
      }
    }
    this.props.getAlLFeatureSettlement({ userId: this.state.suserid });
    const result = {
      catgoryId: "",
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      sortBy: "",
      userId: this.state.suserid,
      searchType: "Available",
      defaultView: "dashboard"
    };

    this.props.getAllFilteredDSettlement(result);
    this.props.getAllSettlement({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: ""
    });
    this.props.getPromotedSettlementByUserId({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      userId: this.state.suserid
    });
    this.props.getEnrollSettlementForUser({
      settlementStatusType: "In Progress",
      userId: this.state.suserid
    });
    this.props.getAttentionSettlementForUser({
      settlementStatusType: "Need Attention",
      userId: this.state.suserid
    });
    this.props.getCompletedSettlements({
      settlementStatusType: "Complete",
      userId: this.state.suserid
    });
    // this.props.getCompleteSettlementForUser({
    //   settlementStatusType: "Complete",
    //   userId: this.state.suserid
    // });
    this.props.getSettlemetEnrichmentQuestion({ userId: this.state.suserid });
    this.setState({
      isLoader: true,
      intervalId
    });
  }

  componentDidMount() {
    const { suserid } = this.state;
    const { setPageName } = this.props
    this.props.RecieveConsumerUserDataClear();
    this.props.RecieveBussnessUserDataClear();
    scrollToComponent(this.dashboardRef, {
      offset: 0,
      align: "middle",
      duration: 100,
      ease: "inCirc"
    });
    this.props.getAllDashboard({ userId: suserid });
    this.props.getUserDashboardSettlementsCounts({ userId: suserid });
    this.setState({ isLoader: true });
    // setPageName("dashbord")
  }

  componentDidUpdate() {
    const {
      ReciveSettlmentanswersResponse,
      getDashboardData,
      receiveDismissSettlement
    } = this.props.data;
    const {
      ReciveSettlmentanswersResponseData,
      getDashboardDataResponse,
      requestDismissSettlementStatus
    } = this.state;
    // const optD = { position: 'top-center' };

    if (getDashboardDataResponse !== getDashboardData) {
      this.setState({
        isLoader: false,
        getDashboardDataResponse: getDashboardData
      });
    }
    if (receiveDismissSettlement !== requestDismissSettlementStatus) {
      this.setState({
        requestDismissSettlementStatus: receiveDismissSettlement
      });
      // this.props.getAllDashboard({ userId: suserid });
      // this.props.getUserDashboardSettlementsCounts({ userId: suserid });
    }

    if (ReciveSettlmentanswersResponse !== undefined) {
      if (
        ReciveSettlmentanswersResponse.eligibilityQuestionDtoList !== undefined
      ) {
        if (
          ReciveSettlmentanswersResponse.eligibilityQuestionDtoList.length > 0
        ) {
          if (
            ReciveSettlmentanswersResponseData !==
            ReciveSettlmentanswersResponse
          ) {
            this.setState({
              ReciveSettlmentanswersResponseData: ReciveSettlmentanswersResponse
            });
            if (ReciveSettlmentanswersResponse.enrollmentId !== "") {
              // toast.info('user enrolls successfully', optD);
              // toast.info('user enrolls successfully', {
              //   position: toast.POSITION.TOP_CENTER,
              // });
              // this.callServiceData();
            }
          }
        }
      }
    }
  }

  async componentWillReceiveProps(nextProps) {
    const { promotedSettlementByUserId } = nextProps.data;
    const fSettlement = nextProps.data.AlLFeatureSettlement;
    const aSettlement = nextProps.data.AllAttentionSettlement;
    const cSettlement = nextProps.data.completedSettlements;
    const allEnriQuestion = nextProps.data.allEnrichmentQuestion;
    const enrollSettleForUser = nextProps.data.EnrollSettlementForUser;
    const { setFilteredDSettlement } = nextProps.data;
    const { getDashboardData } = nextProps.data;
    const { getDashboardDataCount } = nextProps.data;

    this.setState({
      allSettlementData: setFilteredDSettlement,
      featureSettlement: fSettlement,
      attentionSettlement: aSettlement,
      completeSettlement : cSettlement,
      allEnrichmentQuestion: allEnriQuestion,
      enrollSettlementForUser: enrollSettleForUser,
      promotedSettlement: promotedSettlementByUserId,
      getDashboardData,
      getDashboardDataCount
    });
  }

  callServiceData = () => {
    this.props.getPromotedSettlementByUserId({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      userId: this.state.suserid
    });
    this.props.getAlLFeatureSettlement({ userId: this.state.suserid });
    const result = {
      catgoryId: "",
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      sortBy: "",
      userId: this.state.suserid,
      searchType: "Available",
      defaultView: "desktop"
    };
    this.props.getAllFilteredDSettlement(result);
    this.props.getEnrollSettlementForUser({
      settlementStatusType: "In Progress",
      userId: this.state.suserid
    });
    this.props.getAttentionSettlementForUser({
      settlementStatusType: "Need Attention",
      userId: this.state.suserid
    });
    // this.props.getCompleteSettlementForUser({
    //   settlementStatusType: "Complete",
    //   userId: this.state.suserid
    // });
    this.props.getCompletedSettlements({
      settlementStatusType: "Complete",
      userId: this.state.suserid
    });
    const userId = localStorage.getItem("userId");
    this.props.getConsumerUser(userId);
    this.props.getAllDashboard({ userId: this.state.suserid });
    this.props.getUserDashboardSettlementsCounts({
      userId: this.state.suserid
    });

    this.setState({ isLoader: true });
  };

  saveAnserTOQuestion = questionObj => {
    this.setState({ isLoader: true });
    this.props.saveSettlementAnswers(questionObj);
    setTimeout(() => {
      this.callServiceData();
    }, 1000);
  };

  saveVehicleSuccessResponser = () => {
    this.setState({ isLoader: true });
    setTimeout(() => {
      this.callServiceData();
    }, 1000);
  };

  callService = async data => {
    const { suserid } = this.state;
    this.props.requestDismissSettlement(data);
    this.setState({ isLoader: true, requestDismissSettlementStatus: [] });
    // this.props.requestDismissSettlementResponse();
    await this.props.getAllDashboard({ userId: suserid });
    await this.props.getUserDashboardSettlementsCounts({ userId: suserid });
    const result = {
      catgoryId: "",
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      sortBy: "",
      userId: this.state.suserid,
      searchType: "Available",
      defaultView: "dashboard"
    };
    await this.props.getAllFilteredDSettlement(result);
    await this.props.getAllSettlement({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: ""
    });
    await this.props.getPromotedSettlementByUserId({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      userId: this.state.suserid
    });
  };

  saveEnrichmentAnswer = (queId, ans) => {
    const data = {
      userId: this.state.suserid,
      value: ans,
      enrichmentQuestionId: queId
    };
    this.props.saveEnrichmentAnswer(data);
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  render() {
    const {
      allSettlementData,
      promotedSettlement,
      featureSettlement,
      attentionSettlement,
      completeSettlement,
      allEnrichmentQuestion,
      enrollSettlementForUser,
      getDashboardData,
      getDashboardDataCount,
      isLoader
    } = this.state;
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <span
        ref={section => {
          this.dashboardRef = section;
        }}
      >
        {loader1}
        <div className="container">
          <div className="main-content bg-grey">
            <Dashboard
              allSettlementData={allSettlementData}
              promotedSettlement={promotedSettlement}
              featureSettlementData={featureSettlement}
              attentionSettlementData={attentionSettlement}
              completeSettlementData = {completeSettlement}
              allEnrichmentQuestionData={allEnrichmentQuestion}
              saveEnrichmentAnswer={this.saveEnrichmentAnswer}
              enrollSettlementForUserData={enrollSettlementForUser}
              requestDismissSettlementActionToClick={this.callService}
              answerToQuestionAction={this.saveAnserTOQuestion}
              saveDataVehicle={this.saveVehicleSuccessResponser}
              getDashboardData={getDashboardData}
              getDashboardDataCount={getDashboardDataCount}
              isLoaderData={isLoader}
            />
          </div>
        </div>
      </span>
    );
  }
}

DashboardContainer.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getAllSettlement,
      getPromotedSettlementByUserId,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
      saveEnrichmentAnswer,
      getAttentionSettlementForUser,
      getCompleteSettlementForUser,
      saveSettlementAnswers,
      getCompletedSettlements,
      requestDismissSettlement,
      getAllFilteredDSettlement,
      clearDataSettlmentanswers,
      RecieveConsumerUserDataClear,
      RecieveBussnessUserDataClear,
      getAllDashboard,
      getUserDashboardSettlementsCounts,
      getConsumerUser,
      requestDismissSettlementResponse,
      logoutUser,
      clearDataEmail
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DashboardContainer)
);
